import { render, staticRenderFns } from "./revisionInfo.vue?vue&type=template&id=29a72486"
import script from "./revisionInfo.vue?vue&type=script&lang=js"
export * from "./revisionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a72486')) {
      api.createRecord('29a72486', component.options)
    } else {
      api.reload('29a72486', component.options)
    }
    module.hot.accept("./revisionInfo.vue?vue&type=template&id=29a72486", function () {
      api.rerender('29a72486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/revision/revisionInfo.vue"
export default component.exports